import { AccountFragment } from 'src/legacy_graphql'

const hasExpenseBucket = (account: AccountFragment): boolean =>
  !!account.expenseReload

export default hasExpenseBucket
